import React, { useEffect, useRef, useState } from "react";


const Loader = () => {
    return (
        <>
            <div className="loader_pos">
                <div className="loader_sp">
                    <img src="/assets/images/Loaderanimation.gif" alt="" />
                </div>
            </div>
        </>
    )

}
export default Loader;